<template>
  <div>
      <card>
    <b-form>
        <b-form-group id="input-group-1"  >
            <label v-if="editing">{{$t('media.identifier')}}</label>
            <b-form-input 
                v-if="editing"
                :disabled="true"
                v-model="localMedia.mediaId"
            ></b-form-input>

            <label>{{$t('media.name')}}</label>
            <b-form-input 
                v-model="localMedia.name"
                required
                :placeholder="$t('media.name')"
            ></b-form-input>

            <b-form-radio v-model="localMedia.mediaType" :disabled="editing" value="image">{{$t('media.image')}}</b-form-radio>
            <b-form-radio v-model="localMedia.mediaType" :disabled="editing" value="url">{{$t('media.url')}}</b-form-radio>

            <div v-if="localMedia.mediaType == 'image' && editing" style="text-align: center;">
               <b-icon v-if="!loading && mediaFile==null" icon="image" style="color: #E8E8E8; margin-top: 30px" font-scale="10.5"></b-icon>
              <Loading v-if="loading"/>
              <b-img :v-if="editing" :src="mediaFile"/>
            </div>

            <div class="wrap" v-if="localMedia.mediaType == 'url' && localMedia.url != null">
              <iframe title="mediaUrl" class="frame"  :src="localMedia.url"></iframe>
            </div>

            <div v-if="!editing" style="text-align: center;">
              <b-icon v-if=" imgFile == null && localMedia.url == null" icon="image" style="color: #E8E8E8;" font-scale="10.5"></b-icon>

              <b-img v-if="localMedia.mediaType == 'image'" :src="newMediaFile"/>
            </div>

            <div v-if="localMedia.mediaType == 'image'">
                <label>{{$t('media.file')}}</label>
                <b-form-file v-model="imgFile" :disabled="editing" id="file-small" :browse-text="$t('file.browse')" :placeholder="$t('file.no_file')" ></b-form-file>
            </div>

            <div v-else>
                <label>{{$t('media.url')}}</label>
                <b-form-input
                    :disabled="editing" 
                    v-model="localMedia.url"
                    required
                    :placeholder="$t('media.url')"
                ></b-form-input> 
           </div>

            <FormButtons 
                @reset="resetForm"
                @submit="uploadFileAndSave"
                @remove="remove"
                :disableReset="editing"
                :disableRemove="!editing"
          >
          </FormButtons>
          <RequestInfo type="custom" :loader="requestLoading" :ok="requestOk" :error="requestError" :okMsg="okMsg" :errorMsg="errorMsg"/>
        </b-form-group>
    </b-form>
      </card>
  </div>

</template>

<script>

import media from '@/store/content/media.js'

export default {
  name: 'MediaEditForm',
  components: {
    
  },
  props: {
    editing: {
        type: Boolean,
        default: false
    },
    media: {
        type: Object,
        default: function() {
            return {
                mediaId: null,
                name: null,
                mediaType: "image",
                url: null,
                mediaUploadToken: null
            }
        }
    }
  },
  data() {
      return {
        uploadFileToken: null,
        imgFile: null,
        loading: true,
        localMedia: Object.assign({}, this.media), // Copy of this.media to not refresh MediaTable.vue automaticaly
        newMediaFile: null,
        requestLoading: false,
        okMsg: "okMsg",
        errorMsg: "errorMsg",
        requestOk: false,
        requestError: false
    }
  },
  computed: {
    mediaFile(){
      var res = this.$store.state.media.mediaFile;
      if(res == null) return null;
      return  res.base64.slice(0, 5) + 'image/jpeg;' + res.base64.slice(5);
    }
  },
  beforeCreate: function() {
      if (!this.$store.state.media ) 
          this.$store.registerModule("media" , media)


  },
  created: function(){
      this.dispatchMediaFile();
  },
  watch: {
    imgFile: function() {
      if (this.imgFile == null) {
        return;
      }
      this.newMediaFile = URL.createObjectURL(this.imgFile);

    },
    media: function() {
      this.localMedia = Object.assign({}, this.media); // Copy of this.media to not refresh MediaTable.vue automaticaly
      this.resetData();
      this.dispatchMediaFile();
    }
  },
  methods:{
      dispatchMediaFile(){
        if(this.localMedia.mediaType == 'url')
          return;

        this.loading = true;
        if(this.editing)
          this.$store.dispatch('media/getMediaFile', {"mediaId": this.localMedia.mediaId})
          .catch(() => {
            //There was a problem during fetching media file
          })
          .finally(() => {
            this.loading = false;
          });
      },
      resetForm(){
        this.localMedia = {
                mediaId: null,
                name: null,
                mediaType: "image",
                url: null,
                mediaUploadToken: null
            };
        this.resetData();
      },
      resetData(){
        this.uploadFileToken = null;
        this.imgFile = null;
        this.newMediaFile = null;
        this.resetRequestInfo();
      },
      resetRequestInfo(){
        this.requestLoading = false;
        this.requestOk = false;
        this.requestError = false;
      },
      uploadFileAndSave(){
        this.resetRequestInfo();
        if(this.localMedia.name == null || 
          this.localMedia.name == '' || 
          (this.localMedia.mediaType == "url" && (this.localMedia.url == null || this.localMedia.url == '')) || 
          (!this.editing && this.localMedia.mediaType == 'image' && this.imgFile == null)) {
            this.requestError = true;
            this.errorMsg = this.$t('media.request.errorFillInForm');
            return;
        }

        this.requestLoading = true;
        if(this.editing){
          //if editing only save, without uploading file
          this.save();
          return;
        }
        if(this.localMedia.mediaType == 'image'){
          this.localMedia.url = this.imgFile.name;

          this.$store.dispatch('media/uploadFile', this.imgFile)
            .then((result) => {
              this.localMedia.mediaUploadToken = result;
              this.save();
            })
            .catch(() => {
              //There was a problem during uploading file
              this.requestLoading = false;
              this.requestError = true;
              this.errorMsg = this.$t('media.request.errorFileMsg')
            })
        }
        else {
          this.save();
        }
        
        
      },
      remove(){
        this.requestLoading = true;
        let params = {
          "mediaId": this.localMedia.mediaId
        }
        this.$store.dispatch('media/delete', params)
                  .then(() => {
                    this.requestOk = true;
                    this.okMsg = this.$t('media.request.okDeleteMsg')
                  })
                  .catch(() => {
                    this.requestError = true;
                    this.errorMsg = this.$t('media.request.errorDeleteMsg')
                  })
                  .finally(() => {
                    this.requestLoading = false;
                  })
      },
      save(){
        let params = {
            mediaId: this.localMedia.mediaId,
            mediaType: this.localMedia.mediaType,
            mediaUploadToken: this.localMedia.mediaUploadToken,
            name: this.localMedia.name,
            url: this.localMedia.url,
          };
        if(!this.editing) 
          params.mediaId = null;

        this.$store.dispatch('media/save', params)
          .then(() => {
            this.resetForm();
            this.requestOk = true;
            this.okMsg = this.$t('media.request.okSaveMsg')
          })
          .catch(() => {
            this.requestError = true;
            this.errorMsg = this.$t('media.request.errorSaveMsg')
          })
          .finally(() => {
            this.requestLoading = false;
          })
      }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
   .wrap
    {
        width: 288px;
        height: 162px;
        padding: 0;
        overflow: hidden;
    }

    .frame
    {
        width: 1920px;
        height: 1080px;
        border: 0;

        -ms-transform: scale(0.15);
        -moz-transform: scale(0.15);
        -o-transform: scale(0.15);
        -webkit-transform: scale(0.15);
        transform: scale(0.15);

        -ms-transform-origin: 0 0;
        -moz-transform-origin: 0 0;
        -o-transform-origin: 0 0;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }

</style>
